var _circle, _circle2, _circle3, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.335,
    cy: 13.335,
    r: 12.335,
    fill: "#433E50"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.335,
    cy: 13.335,
    r: 12.335,
    fill: "#D0BCFF",
    fillOpacity: 0.11
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.335,
    cy: 13.335,
    r: 12.335,
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2122_471",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2122_471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0208 19.0516C9.54745 19.0516 9.14298 18.8831 8.80744 18.5461C8.4719 18.2091 8.30414 17.804 8.30414 17.3307V12.0807C8.30414 11.6075 8.47264 11.2024 8.80964 10.8654C9.14663 10.5284 9.55174 10.3599 10.025 10.3599H9.98122V9.38281C9.98122 8.53037 10.274 7.80684 10.8595 7.21223C11.445 6.61762 12.1596 6.32031 13.0033 6.32031C13.8469 6.32031 14.5604 6.61762 15.1437 7.21223C15.7271 7.80684 16.0187 8.53037 16.0187 9.38281V10.3599H15.975C16.4482 10.3599 16.8533 10.5284 17.1903 10.8654C17.5273 11.2024 17.6958 11.6075 17.6958 12.0807V17.3307C17.6958 17.804 17.5273 18.2091 17.1901 18.5461C16.853 18.8831 16.4478 19.0516 15.9744 19.0516H10.0208ZM10.025 17.3307H15.975V12.0807H10.025V17.3307ZM13.0031 15.7557C13.2927 15.7557 13.5396 15.6526 13.7437 15.4464C13.9479 15.2401 14.05 14.9922 14.05 14.7026C14.05 14.413 13.9469 14.1661 13.7406 13.962C13.5344 13.7578 13.2865 13.6557 12.9969 13.6557C12.7073 13.6557 12.4604 13.7588 12.2562 13.9651C12.0521 14.1713 11.95 14.4192 11.95 14.7088C11.95 14.9984 12.0531 15.2453 12.2593 15.4495C12.4656 15.6536 12.7135 15.7557 13.0031 15.7557ZM11.7021 10.3599H14.2979V9.38281C14.2979 9.01013 14.1739 8.69335 13.926 8.43246C13.6781 8.17158 13.3694 8.04115 13 8.04115C12.6305 8.04115 12.3218 8.17158 12.0739 8.43246C11.826 8.69335 11.7021 9.01013 11.7021 9.38281V10.3599Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.ea8bd82c6c103b6986ab493a79df23ef.svg";
export { ForwardRef as ReactComponent };